<div class="d-flex justify-content-end">
    <!-- apenas usuario com CI pode visualizar o page-actions-view -->
    <mmp5-mm-icons *ngIf="userHasCI" [icon]="['icon','icon-toolbar-config']" (click)="open()" [ngClass]="isOpen ? 'active' : 'inactive'"></mmp5-mm-icons>
    <div #action class="actions">
    </div>
</div>
